var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1232_7196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9L15.4237 9.26546C15.5254 9.1031 15.5254 8.8969 15.4237 8.73454L15 9ZM15 9C15.4237 9.26546 15.4236 9.2656 15.4235 9.26575L15.4233 9.26615L15.4226 9.2673L15.4203 9.27095L15.4122 9.28357C15.4054 9.29431 15.3955 9.30967 15.3827 9.32932C15.357 9.36863 15.3196 9.42518 15.271 9.4965C15.1738 9.63909 15.0316 9.84105 14.8491 10.0826C14.4847 10.565 13.9564 11.2095 13.3015 11.8559C12.0123 13.1282 10.1392 14.5 8 14.5C5.86077 14.5 3.98771 13.1282 2.69851 11.8559C2.04357 11.2095 1.5153 10.565 1.15094 10.0826C0.968439 9.84105 0.826246 9.63909 0.729034 9.4965C0.68041 9.42518 0.642985 9.36863 0.617344 9.32932C0.604522 9.30967 0.594642 9.29431 0.587776 9.28357L0.579747 9.27095L0.577444 9.2673L0.576723 9.26615L0.576471 9.26575C0.576375 9.2656 0.57629 9.26546 1 9M15 9C15.4237 8.73454 15.4236 8.7344 15.4235 8.73425L15.4233 8.73385L15.4226 8.7327L15.4203 8.72905L15.4122 8.71643C15.4054 8.70569 15.3955 8.69033 15.3827 8.67068C15.357 8.63137 15.3196 8.57482 15.271 8.5035C15.1738 8.36091 15.0316 8.15895 14.8491 7.91736C14.4847 7.43504 13.9564 6.7905 13.3015 6.14413C12.0123 4.87179 10.1392 3.5 8 3.5C5.86077 3.5 3.98771 4.87179 2.69851 6.14413C2.04357 6.7905 1.5153 7.43504 1.15094 7.91736C0.968439 8.15895 0.826246 8.36091 0.729034 8.5035C0.68041 8.57482 0.642985 8.63137 0.617344 8.67068C0.604522 8.69033 0.594642 8.70569 0.587776 8.71643L0.579747 8.72905L0.577444 8.7327L0.576723 8.73385L0.576471 8.73425C0.576375 8.7344 0.57629 8.73454 1 9M1 9L0.57629 9.26546C0.47457 9.1031 0.47457 8.8969 0.57629 8.73454L1 9Z",
    fill: "white",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 2.5,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 0.5,
    stroke: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_7196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon_view.bdf145efcdd3acb5b9331cf6361ae6ef.svg";
export { ForwardRef as ReactComponent };